/* Žurnál 2026 – farebné krúžky v kartách produktov */
document.addEventListener('click', function (e) {
  var s = e.target.closest('.zj-swatch'); if (!s) return;
  var card = s.closest('[data-zj-card]'); if (!card) return;
  card.querySelectorAll('.zj-swatch').forEach(function (x) { x.classList.toggle('is-active', x === s); });
  var img = card.querySelector('[data-zj-img]');
  if (img && s.dataset.img) { img.removeAttribute('srcset'); img.src = s.dataset.img; }
  if (s.dataset.url) card.querySelectorAll('[data-zj-link]').forEach(function (a) { a.href = s.dataset.url; });
});

/* Žurnál 2026 – newsletter (popup + päta) → Klaviyo */
(function () {
  var KEY = 'zj:news', DAY = 864e5;
  function get() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
  function set(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }

  function subscribe(email, source) {
    var c = window.zjNews || {};
    var body = { data: { type: 'subscription', attributes: {
      custom_source: 'zurnal.sk ' + source + ' (' + (c.lang || 'sk') + ')',
      profile: { data: { type: 'profile', attributes: { email: email, properties: { jazyk: c.lang || 'sk' },
        subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } }
    }, relationships: { list: { data: { type: 'list', id: c.list } } } } };
    return fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(c.company), {
      method: 'POST', headers: { 'content-type': 'application/vnd.api+json', revision: '2025-07-15' }, body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error(r.status); });
  }

  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-zj-news]'); var c = window.zjNews;
    if (!f || !c || !c.company || !c.list) return;          // bez nastavení ostáva Shopify formulár
    e.preventDefault();
    var input = f.querySelector('input[type=email]'), btn = f.querySelector('button[type=submit]'), msg = f.querySelector('[data-zj-news-msg]');
    if (btn) btn.disabled = true;
    subscribe(input.value.trim(), f.getAttribute('data-zj-news')).then(function () {
      set({ done: 1 });
      if (msg) { msg.textContent = c.ok; msg.hidden = false; }
      f.querySelector('.zj-form__row').hidden = true;
      if (window.dataLayer) window.dataLayer.push({ event: 'newsletter_signup', source: f.getAttribute('data-zj-news') });
    }).catch(function () {
      if (msg) { msg.textContent = c.err; msg.hidden = false; }
      if (btn) btn.disabled = false;
    });
  });

  var d = document.getElementById('zj-pop');
  if (!d || typeof d.showModal !== 'function') return;
  var s = get(), force = location.search.indexOf('zj_pop=1') > -1;   // ?zj_pop=1 = test, ignoruje uložený stav
  // Prišiel z e-mailu/Klaviya = už je v zozname → nikdy
  if (/[?&](_kx|utm_medium=email|utm_source=klaviyo)/i.test(location.search)) { set({ done: 1 }); return; }
  if (!force && (s.done || (s.closed && Date.now() - s.closed < 30 * DAY) || location.search.indexOf('zj_pop=0') > -1)) return;
  var views = 0; try { views = +sessionStorage.getItem('zj:views') + 1; sessionStorage.setItem('zj:views', views); } catch (e) {}
  var start = Date.now(), minMs = (+d.dataset.delay || 30) * 1000, shown = false;

  function open() {
    if (shown || document.querySelector('dialog[open]')) return;
    shown = true; d.showModal(); set({ closed: Date.now() });   // zobrazenie sa počíta ako „videl", ďalších 30 dní nič
  }
  function close() { d.close(); }
  d.addEventListener('click', function (e) {
    if (e.target.closest('[data-zj-pop-close]')) return close();
    if (e.target !== d) return;
    var r = d.getBoundingClientRect();                        // klik na pozadie (mimo okna) zatvorí
    if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) close();
  });

  if (force) return void setTimeout(open, 500);
  if (matchMedia('(pointer: fine)').matches) {
    // exit-intent až od 2. stránky – nie pri prvom rýchlom pozretí
    document.addEventListener('mouseout', function (e) { if (views >= 2 && !e.relatedTarget && e.clientY <= 0 && Date.now() - start > 8000) open(); });
  }
  setTimeout(function () { if (views >= 2) open(); }, minMs);
  addEventListener('scroll', function () {
    if (views >= 2 && Date.now() - start > 10000 && scrollY + innerHeight > document.body.scrollHeight * 0.5) open();
  }, { passive: true });
})();

/* Žurnál 2026 – odkaz z PDP na sekciu „Nemáme čo skrývať“ (téma inak kotvy blokuje) */
document.addEventListener('click', function (e) {
  var a = e.target.closest('a.zj-acc-link'); if (!a) return;
  var t = document.querySelector(a.getAttribute('href')); if (!t) return;
  e.preventDefault(); e.stopImmediatePropagation();
  var y0 = scrollY; t.scrollIntoView({ behavior: 'smooth', block: 'start' });
  setTimeout(function () { if (scrollY === y0) t.scrollIntoView({ behavior: 'instant', block: 'start' }); }, 400);   // poistka, keď plynulé skrolovanie nejde
  history.replaceState(null, '', a.getAttribute('href'));
}, true);
